// extracted by mini-css-extract-plugin
export default {"root":"XU5nAVXRnPxkYTbiOLRV"};